import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { usePqrReceptionChannelDetail } from './hook';
import { PqrReceptionChannelData } from './data';
import { PqrReceptionChannelParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    PQR_RECEPTION_CHANNEL_NEW,
    PQR_RECEPTION_CHANNEL,
    PQR_RECEPTION_CHANNEL_EDIT,
    PQR_RECEPTION_CHANNEL_DETAIL,
} from '../../../../../routes/paths';
import { PqrReceptionChannelRegisterHistory } from './registerHistory';

export const PqrReceptionChannelDetail = () => {
    const {
        pqrReceptionChannel,
        pqrReceptionChannelHistorical,
        showHistorical,
        setShowHistorical,
    } = usePqrReceptionChannelDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle canal de recepción PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrReceptionChannel?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_RECEPTION_CHANNEL_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_RECEPTION_CHANNEL,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_RECEPTION_CHANNEL_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_RECEPTION_CHANNEL_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrReceptionChannel?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <PqrReceptionChannelParamsHistorical
                            historical={pqrReceptionChannelHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <PqrReceptionChannelData data={pqrReceptionChannel} />
                </LayoutModule>
            </LayoutModule>
            <PqrReceptionChannelRegisterHistory
                pqrReceptionChannel={pqrReceptionChannel}
            />
        </>
    );
};
